import { IClassname } from '@/lib/shared/model/classname';

export const DressingRoom = ({ className }: IClassname) => {
  return (
    <svg
      width="32"
      className={className}
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_14276_548)">
        <path
          d="M23.6675 7.28125L28.4086 8.64862C28.7424 8.76037 29.0255 8.98726 29.2073 9.2887C29.3891 9.59014 29.4578 9.94644 29.4009 10.2938C29.344 10.6412 29.1654 10.9571 28.8969 11.1848C28.6285 11.4125 28.2877 11.5372 27.9357 11.5367H25.5844"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.9678 3.01302C21.9703 2.67742 22.0721 2.35008 22.2604 2.07227C22.4487 1.79445 22.715 1.57859 23.0258 1.45191C23.3366 1.32523 23.6779 1.29339 24.0067 1.3604C24.3356 1.42742 24.6372 1.59029 24.8737 1.82849C25.1101 2.06669 25.2707 2.36955 25.3352 2.69889C25.3998 3.02823 25.3654 3.36932 25.2364 3.67914C25.1074 3.98896 24.8895 4.25366 24.6103 4.43986C24.3311 4.62605 24.003 4.72542 23.6674 4.72543V7.28126"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.3895 10.0543C22.3895 10.4475 22.2333 10.8245 21.9553 11.1025C21.6773 11.3805 21.3003 11.5367 20.9071 11.5367H12.3706C12.0186 11.5372 11.6779 11.4125 11.4094 11.1848C11.141 10.9571 10.9623 10.6412 10.9055 10.2938C10.8486 9.94644 10.9172 9.59014 11.099 9.2887C11.2808 8.98726 11.564 8.76037 11.8978 8.64862L16.6389 7.28125L21.3799 8.64862C21.6753 8.74597 21.9322 8.93451 22.1136 9.18711C22.295 9.43971 22.3916 9.74334 22.3895 10.0543Z"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.9392 3.01302C14.9417 2.67742 15.0436 2.35008 15.2318 2.07227C15.4201 1.79445 15.6864 1.57859 15.9972 1.45191C16.308 1.32523 16.6493 1.29339 16.9782 1.3604C17.307 1.42742 17.6087 1.59029 17.8451 1.82849C18.0815 2.06669 18.2421 2.36955 18.3067 2.69889C18.3712 3.02823 18.3368 3.36932 18.2078 3.67914C18.0788 3.98896 17.861 4.25366 17.5818 4.43986C17.3025 4.62605 16.9744 4.72542 16.6388 4.72543V7.28126"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.30396 3.23047H12.8052"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.1377 21.7598H6.41561"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.083 21.7598H15.3609"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.1377 26.8721H6.41561"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.083 26.8721H15.3609"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.696 3.23047H28.1401"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.30396 30.7055V17.9264C1.30396 17.5874 1.43859 17.2624 1.67825 17.0227C1.9179 16.7831 2.24295 16.6484 2.58187 16.6484H17.9169C18.2558 16.6484 18.5808 16.7831 18.8205 17.0227C19.0602 17.2624 19.1948 17.5874 19.1948 17.9264V30.7055"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.30396 19.2041H19.1948"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.30396 29.4277H19.1948"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.30396 24.3154H19.1948"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.2493 19.2041V29.4274"
          stroke="#22364A"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_14276_548">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0 0.00976562)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
